/*
 * @Author: hq 552370074@qq.com
 * @Date: 2024-05-22 15:03:34
 * @LastEditors: hq 552370074@qq.com
 * @LastEditTime: 2024-05-31 10:36:45
 * @FilePath: \runhong-qt\src\store.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
export default new Vuex.Store({
  // 这是权限
  state: {
    firstlogin: false,
    shortName: "",
    companyLogo: "",
    permissions: [],
    pid: "",
    Company: "",
    bid: "",
    xid: "",
    isClickProject: false,
    token: "",
    xidName: "",
    roleName: "",
    jobs: [],
    ProjectList: [],
    paths: "",
    isProject: false,
    ifEnterprise: false,
    uid: "",
    projectInfo: null,
    UserImgs: "",
    adminSetting: {
      //平台设置
      isHave: false,
      adst02: "",
      adst03: "",
      adst05: "",
      adst06: "",
      ptbaArr: "",
    },
    // 振南
    // baseUrl: 'http://192.168.1.62:64305',
    // 群坡
    // baseUrl: 'http://192.168.1.237:64304',
    // baseUrl2: 'http://192.168.1.237:64304',
    // 温帅韬
    // baseUrl: "http://192.168.1.102:64304/",
    // baseUrl2: "http://192.168.1.102:64304/",
    //正式环境
    // baseUrl: 'http://106.14.46.99:8066',
    baseUrl: "https://api.shznjz.cn",
    baseUrl2: "http://api.shznjz.cn",
    // baseUrl: 'http://101.132.170.121:8006/',
    // baseUrl2: "http://101.132.170.121:8006/",
    userImgs: null,
    btnStyle: ["btnss", "btns", "btns", "btns", "btns"],
    nums: 3,
    RouterPath: "",
    MenuTemplateList: [],
    projectfunctiontemplates: [],
  },
  mutations: {
    pidUpdate(state, gid) {
      state.pid = gid;
    },
    updateToken(state, token) {
      state.token = token;
    },
    sessionModelUrl2(state, url) {
      state.sessionModelUrl = url;
    },
    xidNameUpdata(state, xidName) {
      state.xidName = xidName;
    },
    xidUpdata(state, xid) {
      state.xid = xid;
    },
    updataisClickProject2(state) {
      state.isClickProject = false;
    },
    SetMenuTemplate(state, list) {
      state.MenuTemplateList = list;
    },
    projectfunctiontemplates(state, list) {
      state.projectfunctiontemplates = list;
    },
  },
  actions: {},
  getters: {
    permissions: (state) => state.permissions,
  },
});
